import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { BaseReminderItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { ReminderListItem } from './reminder-list-item';

type ReminderListProps = {
  loading?: boolean;
  items: BaseReminderItemDataFragment[];
  onClick?: (value: BaseReminderItemDataFragment) => void;
};

export function ReminderList({
  loading = false,
  onClick,
  ...props
}: ReminderListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.id} className="content-list__item">
          <ReminderListItem reminder={option} onClick={onClick} />
        </div>
      ))}
    </div>
  );
}
